import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit {
  @Input() message: string | undefined;
  @Output() close = new EventEmitter<void>();

  constructor(  public auth: AuthService) {}

  ngOnInit(): void {}

  onClose() {
    this.close.emit();
  }
}
